export default __webpack_public_path__ + "static/media/Slide20.3dd8eff1.PNG";